import * as React from 'react';
import {generatePath} from 'react-router-dom';

import {CheckboxButton} from 'shells/button/checkbox-button/checkbox-button';
import {CopyButton} from 'shells/button/copy-button/copy-button';
import {HtmlLinkIcon} from 'shells/icon/svg/html-link-icon';
import {Link} from 'shells/link/link';

import type {MeetingFragment} from 'nutshell-graphql-types';

import {AllowBookingButton} from './allow-bookings/allow-booking-button';
import {AssignManagedMeetingButton} from './managed-meetings/assign-managed-meeting-button';
import {ShareMeetingButton} from './share-meeting/share-meeting-button';

type Props = {
    meeting: MeetingFragment;
    activeTab: string;
    onUpdateIsHidden: (isHidden: boolean) => void;
    onUpdateIsActive: (isActive: boolean) => void;
};

export function MeetingPageButtons(props: Props) {
    if (props.meeting.isManagedTemplate) {
        return <AssignManagedMeetingButton meeting={props.meeting} activeTab={props.activeTab} />;
    }

    return (
        <>
            {(props.meeting.isShowable || props.meeting.isHideable) && (
                <CheckboxButton
                    label='Show on your public meeting list'
                    checked={!props.meeting.isHidden}
                    onChange={() => {
                        props.onUpdateIsHidden(!props.meeting.isHidden);
                    }}
                />
            )}
            <AllowBookingButton
                label='Let people book this meeting'
                checked={props.meeting.isActive}
                onChange={() => {
                    props.onUpdateIsActive(!props.meeting.isActive);
                }}
            />
            <Link
                variant='button-secondary'
                size='big'
                newTab={true}
                href={generatePath('/sales/scheduler/:meetingId/:tab', {
                    meetingId: props.meeting.id,
                    tab: 'meeting-preview',
                })}
            >
                Preview
            </Link>
            {NutClientConfig.canUseScheduler && (
                <CopyButton
                    size='big'
                    contentToCopy={props.meeting.publicMeetingLink}
                    icon={HtmlLinkIcon}
                    text={{
                        button: 'Copy link',
                        copiedButton: 'Copy link',
                        tooltip: 'Copy link to meeting',
                        copiedTooltip: 'Copied!',
                    }}
                />
            )}
            <ShareMeetingButton meeting={props.meeting} />
        </>
    );
}
